import React, { useEffect, useState } from "react";
import BlogCard from "./BlogCard";
import axios from "axios";
import { Loader2 } from "lucide-react";

function BlogsPanel() {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const blogsPerPage = 9;

  const lastIndex = currentPage * blogsPerPage;
  const firstIndex = lastIndex - blogsPerPage;

  const currentBlogs = blogs.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get("https://goawin.xyz/api/domain/blogs", {
        withCredentials: true,
      });

      setBlogs(res.data.data || res.data.blogs || []);
    } catch (err) {
      console.log("Server Error");
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) {
    return (
      <section className="relative flex min-h-[500px] items-center justify-center overflow-hidden bg-[#f8f8f8] py-16 dark:bg-[#050505]">
        <div className="absolute left-0 top-0 h-[500px] w-[500px] rounded-full bg-primary/10 blur-[140px]" />
        <div className="absolute bottom-0 right-0 h-[500px] w-[500px] rounded-full bg-orange-300/10 blur-[140px]" />

        <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] bg-[size:70px_70px] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)]" />

        <div className="relative z-10 flex flex-col items-center gap-4">
          <Loader2 className="h-10 w-10 animate-spin text-primary" />

          <p className="text-sm font-semibold text-gray-600 dark:text-gray-300">
            Loading blogs...
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="relative flex items-center justify-center overflow-hidden bg-[#f8f8f8] py-16 dark:bg-[#050505]">
      <div className="absolute left-0 top-0 h-[500px] w-[500px] rounded-full bg-primary/10 blur-[140px]" />
      <div className="absolute bottom-0 right-0 h-[500px] w-[500px] rounded-full bg-orange-300/10 blur-[140px]" />

      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] bg-[size:70px_70px] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)]" />

      <div className="relative mx-auto max-w-7xl px-4">
        {blogs.length > 0 ? (
          <>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {currentBlogs.map((blog, index) => (
                <BlogCard
                  key={blog._id || index}
                  link={`/blog/${blog.slug}`}
                  image={`https://goawin.xyz/${blog.featuredImage}`}
                  title={blog.title}
                  date={blog.createdAt}
                  category={blog.category?.name || "Blog"}
                  author={blog.teamMember?.name || "Admin"}
                />
              ))}
            </div>

            {totalPages > 1 && (
              <div className="mt-10 flex justify-end gap-2">
                <button
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                  className="rounded border border-primary px-3 py-1 text-sm text-primary disabled:cursor-not-allowed disabled:opacity-40"
                >
                  Prev
                </button>

                <button className="rounded bg-primary px-3 py-1 text-sm text-white">
                  {currentPage} / {totalPages}
                </button>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() =>
                    handlePageChange(Math.min(currentPage + 1, totalPages))
                  }
                  className="rounded border border-primary px-3 py-1 text-sm text-primary disabled:cursor-not-allowed disabled:opacity-40"
                >
                  Next
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="mt-10 rounded-3xl border border-gray-200 bg-white p-10 text-center text-gray-500 dark:border-white/10 dark:bg-white/[0.04] dark:text-gray-300">
            No blogs found.
          </div>
        )}
      </div>
    </section>
  );
}

export default BlogsPanel;
